import gql from 'graphql-tag';

import { TaskFragment } from 'common/components/TasksWidget/queries';

export const subscribedTaskCreated = gql`
  subscription subscribedTaskCreated {
    create: taskCreated(subscribed: true) {
      ...Task
    }
  }
  ${TaskFragment}
`;

export const subscribedTaskUpdated = gql`
  subscription subscribedTaskUpdated($id: ID!) {
    update: taskUpdated(id: $id) {
      ...Task
    }
  }

  ${TaskFragment}
`;
